import React, { useState, useEffect } from 'react'

export default ({message}) => {
  if (!message) return null

  return (
    <div className="text-red-700 text-xs mt-2 italic">
      {message}
    </div>
  )
}